// extracted by mini-css-extract-plugin
export var adjacentSlide = "_sy-9";
export var arrowButtonContainer = "_sy-5";
export var arrowButtonIcon = "_sy-6";
export var carouselArrowButton = "_sy-2";
export var carouselElementContainer = "_sy-1";
export var currentSlide = "_sy-8";
export var left = "_sy-3";
export var otherSlide = "_sy-a";
export var productCarouselContainer = "_sy-0";
export var right = "_sy-4";
export var sliderOverflow = "_sy-7";